import * as React from 'react';
import {SVGProps} from 'react';

const NotificationsEmptySvg = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={106} height={88} fill="none" {...props}>
		<g clipPath="url(#a)">
			<path
				fill="#E8927C"
				d="M25.831 13.464c-1.937-.942-4.026-1.268-6.145-.79-2.766.623-14.215 6.405-13.384 14.856.115 1.17.577 3.536 2.95 6.2l16.58-20.266Z"
			/>
			<path
				fill="#69AE9A"
				d="M96.365 6.648c-.608-1.116-1.523-1.786-2.576-1.887-2.097-.202-3.96 1.921-4.241 4.833-.28 2.912 1.144 5.351 3.243 5.553 3.392.325 5.427-5.099 3.574-8.499Zm-1.247.68c.878 1.61.638 4.134-.534 5.552-.5.605-1.087.907-1.657.854-1.262-.121-2.162-1.955-1.965-4.004.297-3.088 2.812-4.874 4.156-2.404v.002ZM81.397 14.04c2 .026 3.734-2.045 4.003-4.847.28-2.912-1.144-5.35-3.242-5.553-1.053-.102-2.078.383-2.887 1.363-.745.9-1.225 2.133-1.354 3.472-.28 2.912 1.144 5.35 3.243 5.552.08.007.158.013.237.013Zm.625-8.986c1.262.121 2.162 1.955 1.965 4.004-.197 2.049-1.432 3.677-2.691 3.556-1.26-.121-2.163-1.955-1.965-4.004.102-1.059.469-2.016 1.034-2.703.42-.507 1.003-.916 1.657-.853ZM74.007 4.497c-1.247-2.288-3.77-2.573-5.463-.525-.744.9-1.224 2.133-1.353 3.472-.28 2.912 1.145 5.35 3.242 5.552 3.43.33 5.415-5.116 3.574-8.499Zm-1.247.68c.425.778.603 1.791.5 2.85-.196 2.048-1.432 3.676-2.69 3.555-1.26-.12-2.162-1.954-1.966-4.003.3-3.112 2.82-4.851 4.156-2.403Z"
			/>
			<path
				fill="#0054B8"
				d="M102.936 11.529c.757 14.21 1.516 28.42 2.277 42.63l-6.496-1.48-6.063 4.124-42.69-10.986 8.97-37.713 44.002 3.425Z"
			/>
			<path
				fill="#69AE9A"
				d="M102.936 11.529a138.582 138.582 0 0 1-10.147 41.567 3139.96 3139.96 0 0 0-48.057-10.7A108.169 108.169 0 0 0 58.933 8.105l44.003 3.425Z"
			/>
			<path
				fill="#FDB713"
				d="m58.933 8.104 44.003 3.425a135.703 135.703 0 0 1-1.078 9.225l-45.032-4.306a63.852 63.852 0 0 1 2.107-8.344Z"
			/>
			<path
				fill="#0054B8"
				d="M93.68 16.009a1.432 1.432 0 1 1 0-2.864 1.432 1.432 0 0 1 0 2.864ZM81.599 14.813a1.432 1.432 0 1 1 0-2.863 1.432 1.432 0 0 1 0 2.863ZM71.072 13.958a1.432 1.432 0 1 1 0-2.864 1.432 1.432 0 0 1 0 2.864Z"
			/>
			<path
				fill="#69AE9A"
				d="M93.167 15.223c.43-.08.664-.553.492-.955a.692.692 0 0 0-.777-.438 1.19 1.19 0 0 1-.57-.025c-.848-.28-1.54-1.89-1.333-4.098a.71.71 0 0 0-1.411-.127c-.254 2.744.661 5.03 2.302 5.573.42.133.866.158 1.297.07ZM81.633 14.288a.714.714 0 0 0 .62-.93.704.704 0 0 0-.735-.486 1.525 1.525 0 0 1-.639-.064c-.882-.302-1.677-1.674-1.589-3.696a.71.71 0 1 0-1.418-.067c-.108 2.494.886 4.54 2.547 5.108.39.13.805.177 1.214.135ZM70.874 13.45a.71.71 0 1 0-.115-1.415 1.508 1.508 0 0 1-.64-.067c-.881-.302-1.68-1.674-1.588-3.696a.71.71 0 0 0-1.418-.067c-.108 2.494.886 4.54 2.547 5.108a2.9 2.9 0 0 0 1.214.137Z"
			/>
			<path
				fill="#DED6C9"
				d="M81.962 28.096a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM72.741 27.025a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM63.438 25.955a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM88.692 37.363a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM79.259 36.68a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM70.039 35.61a3.49 3.49 0 1 1 0-6.981 3.49 3.49 0 0 1 0 6.98ZM60.736 34.54a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM86.53 45.948a3.49 3.49 0 1 1 0-6.981 3.49 3.49 0 0 1 0 6.98ZM77.098 45.264a3.49 3.49 0 1 1 0-6.98 3.49 3.49 0 0 1 0 6.98ZM67.878 44.194a3.49 3.49 0 1 1 0-6.981 3.49 3.49 0 0 1 0 6.98Z"
			/>
			<path
				fill="#EF402F"
				d="m3.557 37.28 58.448-7.09 7.149-4.776-8.034-2.533-58.45 7.093C1.2 30.986.498 32.757.896 34.394c.504 2.07 2.5 2.83 2.66 2.886Z"
			/>
			<path fill="#0054B8" d="M66.467 24.553s-1.043.986.298 2.457l2.389-1.596-2.687-.86Z" />
			<path
				fill="#0093C4"
				d="M47.462-.44h13.446c.794 0 1.438.643 1.438 1.437v9.35c0 .795-.644 1.438-1.438 1.438H47.462a1.438 1.438 0 0 1-1.438-1.437V.997c0-.794.644-1.437 1.438-1.437Z"
			/>
			<path
				fill="#0093C4"
				d="m60.935 10.495-1.811 3.532a.589.589 0 0 1-1.05-.006l-1.757-3.528 4.618.002Z"
			/>
			<path fill="#DED6C9" d="M52.813 1.486h2.744v8.373h-2.744V1.486Z" />
			<path fill="#DED6C9" d="M58.371 4.3v2.744h-8.373V4.301h8.373Z" />
			<path
				fill="#E8927C"
				d="M25.832 13.464c.073.135.685 1.207 2.005 1.433 1.345.232 2.29-.608 2.399-.708l.068-5.78-2.688-.442-1.784 5.497Z"
			/>
			<path
				fill="#954E38"
				d="m27.473 8.95.061-.721 2.767.455-.033 2.784a2.475 2.475 0 0 1-1.33-.216c-1.29-.619-1.455-2.192-1.465-2.302Z"
			/>
			<path
				fill="#E8927C"
				d="M29.551 8.828a3.234 3.234 0 1 1 0-6.468 3.234 3.234 0 0 1 0 6.468Z"
			/>
			<path
				fill="#E8927C"
				d="M32.777 5.752a57.477 57.477 0 0 1-.137 1.575c-.122 1.205-.193 1.52-.363 1.87-.112.226-.326.664-.742.964-.987.712-2.576.268-3.525-.407-1.025-.728-1.385-1.792-1.506-2.234 0 0-.068-.272-.179-2.08 3.872.184 2.39.113 6.452.312Z"
			/>
			<path
				fill="#0054B8"
				d="M8.569 39.292C5.541 46.775 6.568 51.875 7.321 54.26c.738 2.335 2.024 4.467 4.592 8.733a121.056 121.056 0 0 0 5.218 7.94l-2.893 17.579h10.775c2.173-4.82 3.145-9.023 3.62-11.952.397-2.443.826-5.193.52-8.69-.65-7.4-3.793-9.705-7.826-25.859L8.569 39.292Z"
			/>
			<path
				fill="#0054B8"
				d="M35.449 43.91a227.526 227.526 0 0 1 8.675 44.602H32.777L28.48 69.254 21.67 51.992l-1.361-7.061 15.14-1.021Z"
			/>
			<path
				fill="#002D87"
				d="M35.278 26.243s-.397 11.969 3.403 21.156C27.195 53.615 13.9 51.587 4.43 43.202a192.113 192.113 0 0 1 9.184-19.977l12.218-9.76 4.404.724 5.042 12.054Z"
			/>
			<path
				fill="#E8927C"
				d="M30.236 14.189s4.816 1.226 7.027 6.048c2.21 4.822 4.877 11.723 4.877 11.723l12.135-4.43 1.744 4.43c-4.57 7.403-12.21 10.864-17.735 8.915-6.739-2.379-8.236-12.072-8.727-15.253-.752-4.862.006-8.945.679-11.433Z"
			/>
			<path
				fill="#002D87"
				d="M27.072 13.669s-4.032-3.312-9.628-.721c-5.596 2.59-6.028 3.945-7.86 3.781-1.83-.163-1.19 3.854-1.19 3.854a7.51 7.51 0 0 0-1.059 1.736s3.41 5.248 7.056 6.766c0 0 3.037-5.24 3.126-5.24.09 0 9.555-10.176 9.555-10.176ZM27.849 13.765s4.43-.28 8.548 2.89c4.117 3.17 2.72 5.428 5.331 7.76.624.556.88.976.984 1.627.186 1.162-.616 2.268-1.356 3.046l.419 2.016s-5.785 5.397-10.231 5.242c-4.446-.154-4.378-10.237-4.474-10.135-.095.1.779-12.446.779-12.446Z"
			/>
			<path
				fill="#002D87"
				d="m30.238 13.957-4.252-.968-.829 2.738s2.856 1.166 2.912 1.166c.056 0 2.17-2.936 2.17-2.936Z"
			/>
			<path
				fill="#0054B8"
				d="M31.544 3.827s-.178 1.98-2.938 1.938c-1.055-.016-1.087.27-1.176.378-.548.669.651 1.985 1.298 4.017.103.325 1.344 4.397-.662 6.733-.77.896-1.75 1.223-2.319 1.404-4.218 1.34-10.226-1.749-10.6-5.308a3.325 3.325 0 0 1 .16-1.459c1.059-2.571 6.216-2.505 7.504-4.312C24.3 5.12 25.064 1.626 27.7 1.19c2.635-.437 4.243 1.171 4.243 1.171.896-.074 1.752.333 2.184 1.051.55.917.327 2.202-.596 2.978l-2.54-.397s1.189-1.173.554-2.166Z"
			/>
			<path
				fill="#E8927C"
				d="M25.797 7.003c-.269-.782 0-1.583.601-1.79.602-.207 1.307.258 1.576 1.04.27.782 0 1.583-.6 1.79-.602.207-1.307-.258-1.577-1.04Z"
			/>
			<path
				fill="#0054B8"
				d="M27.256 7.329a.346.346 0 0 0 .295-.191.112.112 0 0 0-.192-.115c-.06.099-.115.09-.168.065-.172-.083-.328-.419-.193-.47.078-.03.234.03.296.063a.112.112 0 0 0 .16-.132c-.046-.147-.297-.88-.684-.896-.316-.013-.433.33-.413.646a.112.112 0 0 0 .224-.013c-.008-.146.023-.42.18-.41.13.006.29.268.398.522a.452.452 0 0 0-.24.01c-.42.159-.074.921.337.921ZM31.96 8.78a2.315 2.315 0 0 1-1.362-.434c-.12.564.268 1.029.648 1.044.288.012.6-.235.714-.61Z"
			/>
			<path
				fill="#E8927C"
				d="M52.066 29.055s.398-1.747 1.668-2.422c1.27-.674 1.848-2.421 2.285-1.19.437 1.23-.616 1.989-.616 1.989s2.387.476 4.173-.193c1.786-.67 2.56-.75 2.62-.205.06.546-.672 1.366-1.816 1.872 0 0 2.717-1.355 2.951-.744.234.61-1.7 1.92-1.7 1.92s2.455-1.277 2.203-.34c-.253.936-2.266 1.963-2.266 1.963s2.256-.61 1.76.238c-.495.848-7.789 3.557-9.829 1.935-2.04-1.622-1.433-4.823-1.433-4.823Z"
			/>
			<path
				fill="#0054B8"
				d="M58.716 29.656a5.63 5.63 0 0 0 2.276-.944.112.112 0 1 0-.137-.177 5.512 5.512 0 0 1-2.179.9.112.112 0 0 0-.044.203.113.113 0 0 0 .084.018ZM59.433 31.055c1.254-.254 2.569-1.025 2.624-1.058a.112.112 0 0 0-.112-.193c-.014.008-1.337.784-2.554 1.032a.112.112 0 0 0 .042.219ZM61.612 31.808a.112.112 0 0 0-.086-.207c-.015.006-1.479.616-2.584.534a.112.112 0 0 0-.118.105.113.113 0 0 0 .104.12c.836.056 1.989-.26 2.684-.552ZM39.597 37.086a.112.112 0 0 0 .11-.09c.581-2.952 2.494-4.936 2.513-4.956a.112.112 0 0 0-.16-.156c-.02.02-1.977 2.049-2.573 5.068a.112.112 0 0 0 .11.134ZM32.778 36.104a.112.112 0 0 0 .09-.178l-1.176-1.606a.113.113 0 0 0-.115-.043c-.023.004-.55.112-1.127-.333-.596-.46-1.333-1.596-1.453-4.403-.233-5.432-1.94-3.424-1.497-9.011a.113.113 0 0 0-.184-.095.112.112 0 0 0-.04.077c-.448 5.667 1.266 3.66 1.496 9.039.1 2.328.62 3.868 1.547 4.576.537.41 1.045.401 1.232.38 1.229 1.678 1.146 1.597 1.227 1.597ZM11.556 27.327a.112.112 0 0 0 .106-.075c1.955-5.567 4.935-9.464 4.965-9.502a.113.113 0 0 0-.022-.155.112.112 0 0 0-.155.018c-.03.039-3.032 3.962-5 9.565a.113.113 0 0 0 .014.102.112.112 0 0 0 .092.047Z"
			/>
			<path
				fill="#DED6C9"
				d="M28.209 71.086a.112.112 0 0 0 .096-.168c-7.134-12.003-6.654-11.215-6.698-11.236-5.065-2.628-6.613-7.741-6.628-7.793a.112.112 0 0 0-.206-.022.112.112 0 0 0-.01.086c.016.052 1.586 5.238 6.712 7.912 7.104 11.95 6.635 11.221 6.734 11.221ZM31.18 56.187c3.705-1.973 3.9-5.89 3.902-5.93a.112.112 0 1 0-.224-.01c0 .039-.195 3.832-3.784 5.742a.113.113 0 0 0-.046.152.112.112 0 0 0 .152.046Z"
			/>
			<path
				fill="#EF402F"
				d="m68.668 15.416 1.74 7.192.882-1.493c.262-.443 1.387-.196 1.047.38l-1.648 2.793c-.173.293-1.001.336-1.096-.06l-2.072-8.553c-.14-.59 1.026-.761 1.147-.259Z"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M106 0H0v88h106z" />
			</clipPath>
		</defs>
	</svg>
);
export default NotificationsEmptySvg;
